import React from 'react';
import { Link, NavLink } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { CHAIN } from '../chain/config';
import BpLogo from './BpLogo';

export default function Footer() {
	const cartItems = useSelector(state => state.products);
	const cartCount = (cartItems || []).reduce((n, i) => n + (parseInt(i.quantity, 10) || 1), 0);

	return (
		<React.Fragment>
			<section className="bp-prefooter">
				<div className="bp-prefooter-inner">
					<div className="bp-prefooter-copy">
						<span className="bp-sec-label">GET STARTED</span>
						<h2>Ready to plug in?</h2>
						<p>Join the on-chain marketplace — shop in seconds or open your own store today.</p>
					</div>
					<div className="bp-prefooter-actions">
						<Link to="/signup" className="bp-btn-primary">Start Shopping</Link>
						<Link to="/join/business" className="bp-btn-ghost">Open Your Shop</Link>
					</div>
				</div>
			</section>

			<footer className="bp-footer">
				<div className="bp-footer-inner">
					<div className="bp-footer-grid">

						<div className="bp-footer-brand">
							<div className="bp-footer-logo"><BpLogo size={34} /></div>
							<p className="bp-footer-tagline">
								The on-chain marketplace of the Birr ecosystem. Shop local, pay in BRC,
								and settle every order on {CHAIN.name}.
							</p>
							<div className="bp-footer-chain">
								<span className="bp-wallet-dot live" />
								<span>Live on {CHAIN.name} · chain {CHAIN.chainId}</span>
							</div>
						</div>

						<div className="bp-footer-col">
							<h4>Marketplace</h4>
							<Link to="/search">Shops</Link>
							<Link to="/products">Products</Link>
							<Link to="/deals">Deals</Link>
							<Link to="/news">News</Link>
						</div>

						<div className="bp-footer-col">
							<h4>Account</h4>
							<Link to="/login">Login</Link>
							<Link to="/signup">Create Account</Link>
							<Link to="/profile/pre-orders">Your Orders</Link>
							<Link to="/join">Sell on BirrPlug</Link>
							<Link to="/contact">Contact Us</Link>
						</div>

						<div className="bp-footer-col">
							<h4>Ecosystem</h4>
							<a href="https://birr.foundation" target="_blank" rel="noreferrer">Birr Foundation ↗</a>
							<a href="https://birr.foundation/wallet" target="_blank" rel="noreferrer">BirrWallet ↗</a>
							<a href={CHAIN.explorerUrl} target="_blank" rel="noreferrer">Block Explorer ↗</a>
							<a href="https://birr.foundation/dex" target="_blank" rel="noreferrer">BirrDEX ↗</a>
						</div>

					</div>

					<div className="bp-footer-bottom">
						<span>© {new Date().getFullYear()} BirrPlug · Powered by {CHAIN.name}. All rights reserved.</span>
						<span className="bp-footer-settle">Every order settled on-chain <span className="jp-gradient-text">⛓</span></span>
						<button className="bp-totop" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} aria-label="Back to top">↑</button>
					</div>
				</div>
			</footer>

			{/* mobile bottom tab bar */}
			<nav className="bp-tabbar" aria-label="Quick navigation">
				<NavLink to="/" end className={({ isActive }) => `bp-tab ${isActive ? 'active' : ''}`}>
					<i className="fa fa-home" /><span>Home</span>
				</NavLink>
				<NavLink to="/search" className={({ isActive }) => `bp-tab ${isActive ? 'active' : ''}`}>
					<i className="fa fa-search" /><span>Shops</span>
				</NavLink>
				<NavLink to="/deals" className={({ isActive }) => `bp-tab ${isActive ? 'active' : ''}`}>
					<i className="fa fa-tag" /><span>Deals</span>
				</NavLink>
				<NavLink to="/cart" className={({ isActive }) => `bp-tab ${isActive ? 'active' : ''}`}>
					<span className="bp-tab-cart">
						<i className="fa fa-shopping-cart" />
						{cartCount > 0 && <em className="bp-tab-badge">{cartCount > 99 ? '99+' : cartCount}</em>}
					</span>
					<span>Cart</span>
				</NavLink>
				<NavLink to="/profile/pre-orders" className={({ isActive }) => `bp-tab ${isActive ? 'active' : ''}`}>
					<i className="fa fa-cube" /><span>Orders</span>
				</NavLink>
			</nav>
		</React.Fragment>
	)
}
